import { Box, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const ModalHeader = ({
  handleClose,
  headerText,
}: {
  handleClose: () => void;
  headerText?: string | React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {headerText && (
        <Typography
          sx={{
            color: "#344054",
            textTransform: "capitalize",
            fontWeight: "bold",
          }}
          variant="h5_med"
        >
          {headerText}
        </Typography>
      )}
      <Box
        onClick={handleClose}
        sx={{
          padding: "10px",
          cursor: "pointer",
          marginLeft: "auto",
        }}
      >
        <ClearIcon
          sx={{
            height: "24px",
            width: "24px",
            color: "gray",
            ":hover": { color: "black" },
          }}
        />
      </Box>
    </Box>
  );
};

export default ModalHeader;
